module.exports = __webpack_public_path__ + "img/tahoe-snow-trees.bacd5ce2.jpg";